
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"45","height":"45","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M10 1a9 9 0 00-9 9v24.837a9 9 0 009 9h24.837a9 9 0 009-9V10a9 9 0 00-9-9H10z","stroke":"#504F4F","stroke-width":"2"}}),_c('path',{attrs:{"d":"M33.092 17.848c-3.091 0-5.607-2.365-5.607-5.272 0-1.083-2.749-1.576-5.303-1.576s-5.303.493-5.303 1.576c0 2.907-2.514 5.272-5.606 5.272a.272.272 0 00-.273.273c0 6.984 5.863 11.135 9.366 13.615.643.457 1.2.85 1.646 1.205.011.009.025.013.038.02l.029.015a.26.26 0 00.103.024c.036 0 .07-.01.104-.024.01-.004.019-.01.029-.015.013-.007.025-.011.037-.02.447-.356 1.003-.75 1.647-1.205 3.503-2.48 9.366-6.63 9.366-13.615a.273.273 0 00-.273-.273h0zm-10.91-6.303c3.079 0 4.758.681 4.758 1.03 0 .35-1.68 1.031-4.758 1.031-3.078 0-4.757-.68-4.757-1.03s1.68-1.03 4.757-1.03zm1.501 19.747c-.574.406-1.074.763-1.5 1.092-.427-.33-.927-.686-1.502-1.092-3.372-2.388-8.983-6.364-9.128-12.912 3.007-.129 5.456-2.304 5.82-5.087.904.585 2.91.859 4.81.859 1.9 0 3.905-.274 4.809-.86.363 2.785 2.812 4.96 5.82 5.088-.146 6.548-5.757 10.524-9.129 12.912h0z","stroke":"#BF9C5F","stroke-width":".8","fill":"#BF9C5F","fill-rule":"nonzero"}})])])
          )
        }
      }
    